<template>
  <span v-if="!to" @click="$emit('click', $event)">
    <slot />
  </span>

  <a
    v-else-if="isAnchor(to)"
    v-scroll-to="isAnchor(to)"
    :href="isAnchor(to)"
    class="cursor-pointer"
    @click="$emit('click', $event)"
  >
    <slot />
  </a>

  <a
    v-else-if="to.startsWith('http')"
    :href="to"
    rel="nofollow noopener"
    target="_blank"
    @click="$emit('click', $event)"
  >
    <slot />
  </a>

  <a
    v-else-if="to.startsWith('tel:') || to.startsWith('mailto:')"
    href="#"
    @click.prevent="special(to)"
  >
    <slot />
  </a>

  <a v-else :href="to" @click="internal($event)">
    <slot />
  </a>
</template>

<script>
export default {
  props: {
    to: { type: String, default: null },
  },
  emits: ['click'],
  methods: {
    isAnchor(to) {
      if (to.startsWith('#')) return to;
      return false;
    },
    special(to) {
      this.$emit('click');
      window.location.href = to.replace(/ /g, '');
    },
    internal(e) {
      this.$emit('click', e);
      if (e.defaultPrevented) return;
      e.preventDefault();
      this.$router.push(this.to);
    },
  },
};
</script>
